import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Welcome from '../components/Welcome';
import ImageBanner from '../components/ImageBanner';
import Stay from '../components/Stay';
import Explorations from '../components/Explorations';
import Dining from '../components/Dining';
import Community from '../components/Community';
import Gallery from '../components/Gallery';
import Footer from '../components/Footer';
import usePageMeta from '../hooks/usePageMeta';

export default function HomePage() {
  usePageMeta(
    'Respiro | Immersive Exploration Between São Vicente and Santo Antão Islands',
    'Explore Hotel Respiro on the island of São Vicente. Our intimate bay is a glorious refuge, an architectural base camp to discover the wonders of São Vicente and Santo Antão islands. 20 lodge rooms, 4 private villas.'
  );

  return (
    <div className="bg-white min-h-screen" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Welcome />
        <ImageBanner />
        <Stay />
        <Explorations />
        <Dining />
        <Community />
        <Gallery />
      </main>
      <Footer />
    </div>
  );
}
